import React from 'react';
import './Accueil.css';
import Countdown from '../../components/countdown/Countdown';

import { SpeechButton } from '../../components/speech-button/speech-button';
import BackgroundCarousel from '../../components/carousel/BackgroundCarousel';

export const Accueil = () => {
   return (
      <div className="hero-container" style={{ height: '100vh', position: 'relative' }}>
         <BackgroundCarousel />
         <div>
            <Countdown />
         </div>
         <div>
            <SpeechButton />
         </div>
      </div>
   );
};
